import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/lib/theme";

export default function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  return (
    <button
      type="button"
      data-testid="theme-toggle-button"
      onClick={toggleTheme}
      aria-label={theme === "dark" ? "Passer en mode clair" : "Passer en mode sombre"}
      aria-pressed={theme === "light"}
      className="relative inline-flex h-10 w-10 items-center justify-center rounded-full border border-gold/30 text-gold transition-all duration-300 hover:border-gold hover:bg-gold/10"
    >
      <span className="sr-only">Changer de thème</span>
      <Moon className={`h-[18px] w-[18px] absolute transition-all duration-500 ${theme === "dark" ? "rotate-0 opacity-100" : "rotate-90 opacity-0"}`} />
      <Sun className={`h-[18px] w-[18px] absolute transition-all duration-500 ${theme === "dark" ? "-rotate-90 opacity-0" : "rotate-0 opacity-100"}`} />
    </button>
  );
}
